/* eslint-disable react/jsx-props-no-spreading */
import React, { SVGProps } from 'react';

const SettingIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    {...props}
    data-palette="SettingIcon">
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="0.2"
      d="M3.33 10.72a4.06 4.06 0 0 1 2.214 1.762l.04.068c.512.887.658 1.908.458 2.866l-.013.064.053.038c.345.245.712.458 1.097.634l.06.028.049-.044A4.061 4.061 0 0 1 10 15.1c1.025 0 1.983.383 2.713 1.036l.048.044.06-.027a6.765 6.765 0 0 0 1.097-.635l.053-.038-.013-.064a4.06 4.06 0 0 1 .459-2.866 4.061 4.061 0 0 1 2.252-1.83l.063-.02.006-.066a6.886 6.886 0 0 0 0-1.268l-.006-.066-.063-.02a4.06 4.06 0 0 1-2.253-1.83 4.06 4.06 0 0 1-.459-2.866l.013-.064-.053-.038a6.759 6.759 0 0 0-1.097-.635l-.06-.027-.048.044A4.06 4.06 0 0 1 10 4.9a4.061 4.061 0 0 1-2.712-1.036l-.05-.044-.059.027a6.758 6.758 0 0 0-1.097.635l-.053.038.013.064c.206.98.042 2-.459 2.866a4.06 4.06 0 0 1-2.252 1.83l-.063.02-.006.066a6.886 6.886 0 0 0 0 1.268l.006.066.063.02zM1.768 10c0-.684.083-1.348.24-1.984a2.6 2.6 0 0 0 2.279-3.945A8.225 8.225 0 0 1 7.72 2.087a2.6 2.6 0 0 0 4.558 0 8.225 8.225 0 0 1 3.434 1.984 2.6 2.6 0 0 0 2.28 3.946 8.267 8.267 0 0 1 0 3.967 2.6 2.6 0 0 0-2.28 3.945 8.225 8.225 0 0 1-3.434 1.984 2.6 2.6 0 0 0-4.558 0 8.224 8.224 0 0 1-3.434-1.984 2.6 2.6 0 0 0-2.28-3.946A8.283 8.283 0 0 1 1.766 10zM10 12.4a2.4 2.4 0 1 1 0-4.8 2.4 2.4 0 0 1 0 4.8zm0-1.467a.933.933 0 1 0 0-1.866.933.933 0 0 0 0 1.866z"
    />
  </svg>
);

export default SettingIcon;
